import {inject, PLATFORM} from 'aurelia-framework';
import {DialogController, DialogService} from 'aurelia-dialog';
import {GroupService} from '../../../../../../services/group/group-service';
import {I18N} from 'aurelia-i18n';
import {CommonDialogs} from '../../../../../controls/dialogs/common-dialogs/common-dialogs';
import {includes, map} from 'lodash';

@inject(DialogService, DialogController, GroupService, CommonDialogs, I18N)
export class OnboardMember {

  contacts: any[];
  emailEntered: string;
  sendInvite: boolean;
  processing: boolean;
  groupId: number;

  constructor(public dialog: DialogService, public controller: DialogController, private __groupService: GroupService, public commonDialogs: CommonDialogs, public i18n: I18N) {
    this.contacts = [];
    this.emailEntered = '';
    this.sendInvite = false;
    this.processing = false;
  }
  activate(groupId) {
    this.groupId = groupId;
  }
  back() {
    this.dialog.open({viewModel: PLATFORM.moduleName('resources/pagelayout/content/group/add-member/add-member'), model: this.groupId}).then(()=>{ // @ts-ignore
      this.controller.close();});
  }
  onboard() {
    if (this.contacts.length) {
      let emails = map(this.contacts, 'email');
      this.processing = true;
      let {response} = this.__groupService.onboardMembers(this.groupId, emails, this.sendInvite);
      response.then(()=>{
        this.processing = false;
        let resultArray = this.getFormatedResult('');
        this.responseDialog(resultArray);
      }).catch((error)=>{
        this.processing = false;
        if (error.responseType == 'html') {
          this.commonDialogs.showMessage(error.response, this.i18n.tr('groups.onboard-members.details'), ['Ok']).then(()=>{
            // @ts-ignore
            this.controller.close();
          });
        } else {
          let resultArray = this.getFormatedResult(error.response);
          this.responseDialog(resultArray);
        }
      });
    }
  }
  uploadList() {
    this.dialog.open({viewModel: PLATFORM.moduleName('resources/pagelayout/content/group/add-member/onboard-member/onboard-bulk/onboard-bulk'), model: this.groupId}).then(()=>{ // @ts-ignore
      this.controller.close();});
  }
  getFormatedResult(response) {
    let emails = map(this.contacts, 'email');
    let formatedResult = [];
    emails.forEach( (email) => {
      if (includes(response, email)) {
        formatedResult.push({'email': email, 'error': true});
      } else {
        formatedResult.push({'email': email, 'error': false});
      }
    });
    return formatedResult;
  }
  responseDialog(profiles) {
    this.dialog.open({viewModel: PLATFORM.moduleName('resources/pagelayout/content/group/add-member/add-member-result/add-member-result'), model: {action: 'onboard', profilesArray: profiles}}).then(()=>{ // @ts-ignore
      this.controller.close();});
  }
}

